import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';

//components
import ResetYourPassword from '../../components/ResetYourPassword';

//styles
import {ResetPasswordView, ResetPasswordWrapper} from './styles';

@inject('store')
@observer
class ResetPasswordViewComponent extends Component {
  render() {
    const {requestResetPassword, isMobile, setPassword, isPhone} = this.props;
    return (
      <ResetPasswordView>
        <ResetPasswordWrapper>
          <ResetYourPassword
            isMobile={isMobile}
            requestResetPassword={requestResetPassword}
            setPassword={setPassword}
            isPhone={isPhone}
          />
        </ResetPasswordWrapper>
      </ResetPasswordView>
    );
  }
}

export default ResetPasswordViewComponent;
